export default __webpack_public_path__ + "static/media/nginx.f01cd3c8.svg";